
import { defineComponent } from "vue";
import CardsWhy from "./CardsWhy.vue";

export default defineComponent({
  name: "WhyBank",
  components: { CardsWhy },
});
